/*
 *		Copyright (c) 2011-2016 Acronis Incorporated. All rights reserved.
 *
 *	This source code may be used only by organizations licensed to use Acronis Access, in conjunction with normal Acronis Access usage.
 *	No portion of it may be redistributed or modified without the written permission of Acronis, Inc. See the Acronis Software License Agreement for more information.
 */

'use strict';

angular.module('accessWebClient')
    .filter('advancedSearch', ['FileExtension', function(FileExtension) {
        return function(nodes, advancedFilters, dateStr) {
            if (!nodes) return;
            if (!advancedFilters) return nodes;
            
            dateStr = dateStr || 'file_modification_date';

            var filteredNodes = [];
            
            for (var i = 0; i < nodes.length; i++) {
                var dateToCompare = new Date(nodes[i][dateStr]),
                    extension = FileExtension.getExtension(nodes[i]['name']).toLowerCase();
                
                if (
                    (!advancedFilters.owner.email || nodes[i]['owner']['email'] === advancedFilters.owner.email) &&
                    (!advancedFilters.period.from || dateToCompare >= advancedFilters.period.from) &&
                    (!advancedFilters.period.to || dateToCompare <= advancedFilters.period.to) &&
                    (!advancedFilters.fileType.extensions || advancedFilters.fileType.extensions.indexOf(extension) !== -1)
                ) {
                    filteredNodes.push(nodes[i])
                }
            }
            
            return filteredNodes;
        };
    }]);
